module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"titleInfo":"Visit info","titleTickets":"Tickets","labelDate":"Date","labelNumber":"Number of tickets","selectNumber":"Please select","groupRegistration":"Register a group","groupRedirect":"http://www.miniatur-wunderland.com/visit/group-offers/groupregistration/","person":"person"}}')
  delete Component.options._Ctor
}
